import "../../js/responsive/lib/jquery.scrollTo.min";
import "../../js/responsive/jquery.validate.min";
import "../../js/responsive/lib/jquery.validate.custom-methods";
